<template>
  <div class="all-view column-view padding-15 scroll-y">

    <div class="row-view">
      <el-button type="primary" icon="el-icon-plus" @click="createEmployee">添加人员</el-button>
    </div>

    <div class="white-block-view-5px padding-15 margin-top-15">
      <el-table :data="list" border ref="table" :loading="loading">
          <el-table-column label="姓名"  align="center">
            <template slot-scope="scope">
              {{ scope.row.employee_name }}
            </template>
          </el-table-column>

        <el-table-column label="所属部门" align="center">
          <template slot-scope="scope">
            {{ scope.row.dept_name }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div style="width: 100%" class="row-view center-view">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="onDeleteEmployeeClick(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>

        <template #empty>
          <yc-no-content des="暂无数据~"></yc-no-content>
        </template>
      </el-table>
    </div>

    <create-promoted-employee-dialog @onRefreshData="onRefreshData" ref="promotedEmployeeDialog"></create-promoted-employee-dialog>
  </div>
</template>

<script>
import createPromotedEmployeeDialog from "@/views/setting/promotedManage/components/createPromotedEmployeeDialog";
export default {
  //新提拔干部管理列表
  name: "PromotedManagement",
  components: {createPromotedEmployeeDialog},
  data() {
    return {
      loading:false,
      list:[
      ]
    }
  },
  methods:{
    onRefreshData(){
      this.getPromotedList();
    },

    /**
     * 获取提拔干部列表
     */
    getPromotedList(){
      this.loading=true;
      this.http.api('getPromotedList')
          .then(res=>{
            if(res.status){
              this.list=res.data;
            }
          })
          .catch(error=>{
            this.loading=false;
          })
    },

    createEmployee(){
      this.$refs.promotedEmployeeDialog.showDialog();
    },

    //删除提拔干部员工
    onDeleteEmployeeClick(item){
      this.$prompt('确认删除人员【'+item.employee_name+'】?', '删除人员', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            this.http.api('deletePromotedPeople', { id: item.id }).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '删除'
                done()
                this.$commonUtils.showMessage("操作成功", 'success')
                this.getPromotedList();
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '删除'
              }
            }).catch(() => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '删除'
            })
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })
    }
  },
  created() {
    this.getPromotedList();
  },

}
</script>

<style scoped>

</style>
